import store from "../store";

export default class DelaiLocationPlugin {
  public static delaiEnMinutes: number = 30;

  /* Retourne vrai si le délai écoulé depuis le début de la location
     dépasse delaiEnMinutes
   */
  public static isDelaiLocationDepasse(): boolean {
    const dateDebut: Date | null =
      store.state.utilisateur.dateDebutCreationLocation;
    if (dateDebut == null) {
      return true;
    }

    const isDelaiLocationDepasse: boolean =
      new Date().getTime() >
      this.addMinutes(dateDebut, this.delaiEnMinutes).getTime();

    //console.log("isDelaiLocationDepasse : " + isDelaiLocationDepasse);

    return isDelaiLocationDepasse;
  }

  private static addMinutes(date: Date, minutes: number): Date {
    const result: Date = new Date(date);
    result.setTime(result.getTime() + minutes * 60000);

    return result;
  }
}
